<sepidz-review [hasSavebutton]="false" class="review">
  <div review-filters>
    <div>
      <section style="margin-top: 2px">
        <sepidz-static-select-review
          valueType="boolean"
          [form]="formGroup"
          title="نمایش مانده ابتدای دوره"
          name="ShowBeforeRemain"
          key="ShowBeforeRemain"
          [items]="[{ Name: 'نمایش مانده ابتدای دوره', Value: true }]">
        </sepidz-static-select-review>
      </section>
      <section style="margin-top: 2px">
        <sepidz-static-select-review
          valueType="boolean"
          [form]="formGroup"
          title="نمایش مانده درخط"
          name="ShowRunningTotal"
          key="ShowRunningTotal"
          [items]="[{ Name: 'نمایش مانده درخط', Value: true }]">
        </sepidz-static-select-review>
      </section>
      <section style="margin-top: 2px">
        <sepidz-static-select-review
          [form]="formGroup"
          valueType="boolean"
          title="عدم نمایش مانده صفر"
          name="NotShowWithRemain"
          key="NotShowWithRemain"
          [items]="[{ Name: 'عدم نمایش مانده صفر', Value: true }]">
        </sepidz-static-select-review>
      </section>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('FilterDocument')">
          <span>فیلتر سند</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'FilterDocument'"></i>
        </div>
        <div *ngIf="selected === 'FilterDocument'">
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              title="از شماره"
              name="StartNumber"
              key="StartNumber"
              [items]="[{ Name: 'از شماره' }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              title="تا شماره"
              name="EndNumber"
              key="EndNumber"
              [items]="[{ Name: 'تا شماره' }]">
            </sepidz-static-select-review>
          </section>
          <section style="margin-top: 2px">
            <sepidz-static-select-review
              valueType="number"
              [form]="formGroup"
              title="شماره پیگیری"
              name="SlaveNo"
              key="SlaveNo"
              [items]="[{ Name: 'شماره پیگیری' }]">
            </sepidz-static-select-review>
          </section>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DocumentType')">
          <span>نوع سند</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'DocumentType'"></i>
        </div>
        <div *ngIf="selected === 'DocumentType'">
          <sepidz-remote-select-review
            title="نوع سند"
            [form]="formGroup"
            name="AccVoucherKind"
            key="AccVoucherKindIds"
            apiName="AccVoucherKind/ReadAccVoucherKindLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DocumentStatus')">
          <span>وضعیت سند</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'DocumentStatus'"></i>
        </div>
        <div *ngIf="selected === 'DocumentStatus'">
          <sepidz-remote-select-review
            title="وضعیت سند"
            [form]="formGroup"
            name="AccStatusKind"
            key="AccStatusKindIds"
            apiName="Lookup"
            systemName="ACC"
            category="StatusKind">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('SystemType')">
          <span>نوع سیستم</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'SystemType'"></i>
        </div>
        <div *ngIf="selected === 'SystemType'">
          <sepidz-remote-select-review
            title="نوع سیستم"
            [form]="formGroup"
            name="SystemKind"
            key="SystemKindIds"
            apiName="Lookup"
            systemName="GNR"
            category="SystemKind">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span>شعب</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'">
          <sepidz-remote-select-review title="نوع سیستم" [form]="formGroup" name="Branch" key="BranchIds" apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DetailType')">
          <span>نوع تفصیلی</span>
          <i class="icon-chevron-right" [class.icon-chevron-up]="selected === 'DetailType'"></i>
        </div>
        <div *ngIf="selected === 'DetailType'">
          <sepidz-remote-select-review
            title="نوع تفصیلی"
            [form]="formGroup"
            name="DetailLedgerKind"
            key="DetailLedgerKindIds"
            apiName="DetailLedgerKind/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset #ssgTabset class="tabset" (tabChange)="selectTab($event)">
      <ssg-tab
        *hasPermission="['Accounting:AccountReview/GetGroupLedger', 'Same']"
        [active]="isActveTab('ClientApp.BackOffice.ACC.GroupLedger.GroupLedger' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.GroupLedger.GroupLedger' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.GroupLedger.GroupLedger' | translate)"
          name="GroupLedger"
          [title]="'ClientApp.BackOffice.ACC.GroupLedger.GroupLedger' | translate"
          apiName="AccountReview/GetGroupLedger"
          areaName="Accounting"
          [groupable]="false"
          [doubleClick]="onDoubleClick"
          [columns]="GetGroupLedgerColumns"
          [filtering]="true"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          aggregatesColumnName="Debit,Credit"
          displayNameColumn="GroupLedgerTitle"
          key="GroupLedgerIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Accounting:AccountReview/GetGeneralLedger', 'Same']"
        [active]="isActveTab('ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedger' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedger' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedger' | translate)"
          name="GeneralLedger"
          [title]="'ClientApp.BackOffice.ACC.GeneralLedger.GeneralLedger' | translate"
          apiName="AccountReview/GetGeneralLedger"
          areaName="Accounting"
          [doubleClick]="onDoubleClick"
          [groupable]="false"
          [columns]="GetGeneralLedgerColumns"
          [filtering]="true"
          [unSortableFilterable]="unSortableFilterable"
          aggregatesColumnName="Debit,Credit"
          displayNameColumn="GeneralLedgerTitle"
          pathPreFix="ACC"
          key="GeneralLedgerIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *hasPermission="['Accounting:AccountReview/GetSubLedger', 'Same']"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.SubLedger' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.SubLedger' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.SubLedger' | translate)"
          name="SubLedger"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.SubLedger' | translate"
          apiName="AccountReview/GetSubLedger"
          areaName="Accounting"
          [doubleClick]="onDoubleClick"
          [columns]="GetSubLedgerColumns"
          [filtering]="true"
          [unSortableFilterable]="unSortableFilterable"
          aggregatesColumnName="Debit,Credit"
          displayNameColumn="SubLedgerTitle"
          pathPreFix="ACC"
          key="SubLedgerIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(1, 'Accounting:AccountReview/GetDetailLedger1')"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger1' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger1' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger1' | translate)"
          name="DetailLedger1"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger1' | translate"
          apiName="AccountReview/GetDetailLedger1"
          areaName="Accounting"
          [columns]="GetDetailLedger1Columns"
          [filtering]="true"
          aggregatesColumnName="Debit,Credit"
          [doubleClick]="onDoubleClick"
          [groupable]="false"
          [unSortableFilterable]="unSortableFilterable"
          displayNameColumn="DetailLedgerTitle"
          key="DetailLedger1Ids">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(2, 'Accounting:AccountReview/GetDetailLedger2')"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger2' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger2' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger2' | translate)"
          name="DetailLedger2"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger2' | translate"
          apiName="AccountReview/GetDetailLedger2"
          areaName="Accounting"
          [columns]="GetDetailLedger2Columns"
          [filtering]="true"
          [doubleClick]="onDoubleClick"
          [groupable]="false"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          aggregatesColumnName="Debit,Credit"
          displayNameColumn="DetailLedger2Title"
          key="DetailLedger2Ids">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(3, 'Accounting:AccountReview/GetDetailLedger3')"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger3' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger3' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger3' | translate)"
          name="DetailLedger3"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger3' | translate"
          apiName="AccountReview/GetDetailLedger3"
          areaName="Accounting"
          [doubleClick]="onDoubleClick"
          [columns]="GetDetailLedger3Columns"
          [filtering]="true"
          [groupable]="false"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          aggregatesColumnName="Debit,Credit"
          displayNameColumn="DetailLedger3Title"
          key="DetailLedger3Ids">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(4, 'Accounting:AccountReview/GetDetailLedger4')"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger4' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger4' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger4' | translate)"
          name="DetailLedger4"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger4' | translate"
          apiName="AccountReview/GetDetailLedger4"
          areaName="Accounting"
          [doubleClick]="onDoubleClick"
          [columns]="GetDetailLedger4Columns"
          [filtering]="true"
          [groupable]="false"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          aggregatesColumnName="Debit,Credit"
          displayNameColumn="DetailLedger4Title"
          key="DetailLedger4Ids">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(5, 'Accounting:AccountReview/GetDetailLedger5')"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger5' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger5' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger5' | translate)"
          name="DetailLedger5"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger5' | translate"
          apiName="AccountReview/GetDetailLedger5"
          areaName="Accounting"
          [doubleClick]="onDoubleClick"
          [columns]="GetDetailLedger5Columns"
          [filtering]="true"
          [groupable]="false"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          aggregatesColumnName="Debit,Credit"
          displayNameColumn="DetailLedger5Title"
          key="DetailLedger5Ids">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(6, 'Accounting:AccountReview/GetDetailLedger6')"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger6' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger6' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger6' | translate)"
          name="DetailLedger6"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger6' | translate"
          apiName="AccountReview/GetDetailLedger6"
          areaName="Accounting"
          [columns]="GetDetailLedger6Columns"
          [filtering]="true"
          aggregatesColumnName="Debit,Credit"
          [doubleClick]="onDoubleClick"
          [groupable]="false"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          displayNameColumn="DetailLedger6Title"
          key="DetailLedger6Ids">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(7, 'Accounting:AccountReview/GetDetailLedger7')"
        [active]="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger7' | translate)"
        [tabTitle]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger7' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.SubLedger.DetailLedger7' | translate)"
          name="DetailLedger7"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger7' | translate"
          apiName="AccountReview/GetDetailLedger7"
          areaName="Accounting"
          [columns]="GetDetailLedger7Columns"
          [filtering]="true"
          aggregatesColumnName="Debit,Credit"
          [doubleClick]="onDoubleClick"
          [groupable]="false"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          displayNameColumn="DetailLedger7Title"
          key="DetailLedger7Ids">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab
        *ngIf="detailLedgerLevelValidate(2, 'Accounting:AccountReview/GetDetailLedger')"
        [tabTitle]="'ClientApp.BackOffice.ACC.DetaiLedger.DetaiLedger' | translate">
        <sepidz-grid-review
          *ngIf="isActveTab('ClientApp.BackOffice.ACC.DetaiLedger.DetaiLedger' | translate)"
          name="DetailLedger"
          [title]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger' | translate"
          apiName="AccountReview/GetDetailLedger"
          areaName="Accounting"
          [columns]="GetDetailLedgerColumns"
          [filtering]="true"
          aggregatesColumnName="Debit,Credit"
          [groupable]="false"
          pathPreFix="ACC"
          [unSortableFilterable]="unSortableFilterable"
          displayNameColumn="DetailLedgerTitle"
          key="DetailLedgerIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab *hasPermission="['Accounting:AccountReview/GetVoucherDetail', 'Same']" tabTitle="گردش حساب">
        <sepidz-grid-review
          #sepidzgrid
          *ngIf="isActveTab('گردش حساب') && GetVoucherDetailColumns && GetVoucherDetailColumns.length > 0"
          name="VoucherDetail"
          title="گردش حساب"
          apiName="AccountReview/GetVoucherDetail"
          areaName="Accounting"
          [columns]="_GetVoucherDetailColumns"
          [selective]="false"
          [filtering]="true"
          defaultSortKeyKind="asc"
          defaultSortKey="SubLedgerCode,DetailLedger1Code,DetailLedger2Code,DetailLedger3Code,DetailLedger4Code,DetailLedger5Code,DetailLedger6Code,DetailLedger7Code,VoucherDate,VoucherNo,RowNumber"
          aggregatesColumnName="Debit,Credit"
          [isModal]="false"
          pathPreFix="ACC"
          [actionTregger]="onActionClick"
          [actions]="actions"
          key="VoucherDetailIds">
        </sepidz-grid-review>
      </ssg-tab>
      <ssg-tab *hasPermission="['Accounting:AccountReview/GetAcoountAnalystic', 'Same']" tabTitle="تراز تحلیلی">
        <sepidz-grid-review
          *ngIf="isActveTab('تراز تحلیلی')"
          name="AcoountAnalystic"
          title="تراز تحلیلی"
          apiName="AccountReview/GetAcoountAnalystic"
          areaName="Accounting"
          [columns]="GetAcoountAnalysticColumns"
          [selective]="false"
          [filtering]="true"
          pathPreFix="ACC"
          aggregatesColumnName="Debit,Credit"
          key="AcoountAnalysticIds">
        </sepidz-grid-review>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
